<template>
    <dashboard-layout :column-count="1">
        <basic-card v-for="setup in setups">
            <template slot="header">Setup [{{setup.systemName}}]</template>
            <h1>Basic parameters:</h1>
            <form-wrapper>
                <form-text-input caption="Date from" v-model="setup.dateFrom"/>
                <form-text-input caption="Date to" v-model="setup.dateTo"/>
            </form-wrapper>
            <h1>Additional columns:</h1>
            <data-table
                :data="setup.parameters"
                :configuration="parameterTableConfig"
                component-id="cashflow-setup-columns"
            />
            <simple-horizontal-layout>
                <empty/>
                <empty/>
                <simple-button @press="saveSetup">Save setup</simple-button>
            </simple-horizontal-layout>
        </basic-card>


    </dashboard-layout>
</template>

<script>
    import DashboardLayout from "../components/layout/DashboardLayout";
    import FormWrapper from "../components/form/FormWrapper";
    import {mapGetters} from "vuex";
    import FormTextInput from "../components/form/FormTextInput";
    import BasicCard from "../components/layout/BasicCard";
    import DataTable from "../components/table/DataTable";
    import SimpleHorizontalLayout from "../components/layout/SimpleHorizontalLayout";
    import Empty from "../components/layout/Empty";
    import SimpleButton from "../components/button/SimpleButton";
    export default {
        name: "CashflowSetupView",
        components: {
            SimpleButton,
            Empty, SimpleHorizontalLayout, DataTable, BasicCard, FormTextInput, FormWrapper, DashboardLayout},
        data: function () {
            return {
                parameterTableConfig: {
                    columns: [
                        {
                            caption: "Display name",
                            datum: d => d.displayName
                        },
                        {
                            caption: "Param type",
                            datum: d => d.paramType
                        }
                    ]
                }
            }
        },
        computed: {
            ... mapGetters({
                setups: "cashflowSetups/cashflowSetups"
            })
        },
        methods: {
            saveSetup() {

            }
        }
    }
</script>

<style lang="scss" scoped>

</style>